/* Still Soft — product page order form.

   Replaces stillsoft-cod.js. Everything the product page does lives here:
   variant selection, per-size quantities, add-ons, offer maths, the policy
   sheets, and handing a fully pre-filled order to Shopify.

   No API token is ever present in this file. See docs/OWNER_HANDOFF.md. */
(function () {
  'use strict';

  var form = document.querySelector('[data-ss-cod]');
  if (!form) return;

  var cfg = {};
  try {
    cfg = JSON.parse(form.getAttribute('data-ss-cod') || '{}');
  } catch (e) {
    cfg = {};
  }

  var offer = cfg.offer || {};
  var variants = cfg.variants || [];

  function money(cents) {
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (cfg.moneyFormat || '{{amount}} EGP').replace('{{amount}}', n);
  }

  var el = {
    submit: form.querySelector('[data-ss-submit]'),
    subtotal: form.querySelector('[data-ss-subtotal]'),
    shipping: form.querySelector('[data-ss-shipping]'),
    total: form.querySelector('[data-ss-total]'),
    savingRow: form.querySelector('[data-ss-saving-row]'),
    savingLabel: form.querySelector('[data-ss-saving-label]'),
    saving: form.querySelector('[data-ss-saving]'),
    lines: form.querySelector('[data-ss-lines]'),
    offerNudge: form.querySelector('[data-ss-offer-nudge]'),
    shipNudge: form.querySelector('[data-ss-ship-nudge]'),
    qtyError: form.querySelector('[data-ss-qty-error]'),
    hp: form.querySelector('[data-ss-hp]'),
    stickyTotal: document.querySelector('[data-ss-sticky-total]'),
    sticky: document.querySelector('[data-ss-sticky]'),
    priceNow: document.querySelector('.ss-price__now'),
    gallery: document.querySelector('[data-ss-gallery]'),
    dots: document.querySelector('[data-ss-dots]')
  };

  /* ================= Validation ================= */

  var rules = {
    name: {
      test: function (v) {
        return v.trim().length >= 3 && /^[\p{L}\s'.-]+$/u.test(v.trim());
      },
      message: 'Please enter your full name, at least 3 letters.'
    },
    phone: {
      test: function (v) {
        return /^01[0125][0-9]{8}$/.test(v.replace(/[\s-]/g, ''));
      },
      message: function (v) {
        var digits = v.replace(/\D/g, '');
        if (digits.length && digits.length < 11) return 'That phone number looks a digit short.';
        if (digits.length > 11) return 'That phone number has a digit too many.';
        return 'Please enter an Egyptian mobile number, starting 010, 011, 012 or 015.';
      }
    },
    governorate: {
      test: function (v) { return v.trim() !== ''; },
      message: 'Please choose your governorate.'
    },
    area: {
      test: function (v) { return v.trim().length >= 2; },
      message: 'Please tell us your area or district.'
    },
    address: {
      test: function (v) { return v.trim().length >= 10; },
      message: 'Please add a bit more detail: street, building, floor and apartment.'
    }
  };

  function fieldOf(name) {
    return form.querySelector('[name="ss_' + name + '"]');
  }

  function setError(name, message) {
    var input = fieldOf(name);
    if (!input) return;
    var box = form.querySelector('[data-ss-error="' + name + '"]');
    if (message) {
      input.setAttribute('aria-invalid', 'true');
      if (box) { box.textContent = message; box.classList.add('is-shown'); }
    } else {
      input.removeAttribute('aria-invalid');
      if (box) { box.textContent = ''; box.classList.remove('is-shown'); }
    }
  }

  function validateField(name) {
    var input = fieldOf(name);
    if (!input) return true;
    var rule = rules[name];
    var ok = rule.test(input.value);
    var msg = typeof rule.message === 'function' ? rule.message(input.value) : rule.message;
    setError(name, ok ? null : msg);
    return ok;
  }

  Object.keys(rules).forEach(function (name) {
    var input = fieldOf(name);
    if (!input) return;
    input.addEventListener('blur', function () { validateField(name); });
    input.addEventListener('input', function () {
      if (input.getAttribute('aria-invalid') === 'true' && rules[name].test(input.value)) {
        setError(name, null);
      }
      saveLead();
    });
  });

  /* ================= Quantities =================
     One stepper per size and colour, so a single order can carry three sizes
     for three people. The old single quantity box could only ever buy one
     variant, which quietly capped every basket. */

  function qtyRows() {
    var rows = [];
    form.querySelectorAll('[data-ss-qrow]').forEach(function (row) {
      var input = row.querySelector('[data-ss-qty-input]');
      var n = Math.max(0, parseInt(input && input.value, 10) || 0);
      if (n > 0) {
        rows.push({
          id: row.getAttribute('data-variant'),
          title: row.getAttribute('data-title') || '',
          price: parseInt(row.getAttribute('data-price'), 10) || 0,
          qty: n,
          productId: cfg.productId,
          minQty: offer.minQty || 0,
          amountOff: offer.amountOff || 0,
          freeEvery: offer.freeEvery || 0,
          xbuy: !!cfg.xbuy,
          xget: !!cfg.xget,
          xamount: cfg.xamount || 0
        });
      }
    });
    return rows;
  }

  function totalUnits() {
    return qtyRows().reduce(function (a, r) { return a + r.qty; }, 0);
  }

  function setQty(row, n) {
    var input = row.querySelector('[data-ss-qty-input]');
    if (!input) return;
    input.value = Math.max(0, n);
    row.classList.toggle('is-active', Math.max(0, n) > 0);
  }

  form.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-qstep]');
    if (!btn) return;
    e.preventDefault();
    var row = btn.closest('[data-ss-qrow]');
    var input = row.querySelector('[data-ss-qty-input]');
    var n = Math.max(0, parseInt(input.value, 10) || 0);
    setQty(row, btn.getAttribute('data-qstep') === 'up' ? n + 1 : n - 1);
    render();
  });

  form.addEventListener('input', function (e) {
    if (e.target.matches('[data-ss-qty-input]')) {
      var row = e.target.closest('[data-ss-qrow]');
      row.classList.toggle('is-active', (parseInt(e.target.value, 10) || 0) > 0);
      render();
    }
  });

  /* ================= Add-ons ================= */

  function addonRows() {
    var rows = [];
    form.querySelectorAll('[data-ss-addon]').forEach(function (box) {
      if (!box.checked) return;
      var wrap = box.closest('.ss-addon');
      var select = wrap && wrap.querySelector('[data-ss-addon-variant]');
      if (!select || !select.value) return;
      var opt = select.options[select.selectedIndex];
      rows.push({
        id: select.value,
        title: box.getAttribute('data-title') || '',
        option: opt ? opt.textContent.trim() : '',
        price: parseInt(opt && opt.getAttribute('data-price'), 10) || 0,
        qty: 1,
        productId: box.getAttribute('data-product'),
        minQty: parseInt(box.getAttribute('data-min-qty'), 10) || 0,
        amountOff: parseInt(box.getAttribute('data-amount-off'), 10) || 0,
        freeEvery: parseInt(box.getAttribute('data-free-every'), 10) || 0,
        xbuy: box.getAttribute('data-xbuy') === 'true',
        xget: box.getAttribute('data-xget') === 'true',
        xamount: parseInt(box.getAttribute('data-xamount'), 10) || 0
      });
    });
    return rows;
  }

  /* ================= Offers =================

     This mirrors the automatic discounts in Shopify admin, and the part that
     matters is how they interact. Every product discount on this store is set
     with combinesWith.productDiscounts = false, so Shopify never adds two of
     them together. It works out each one that applies and gives the customer
     the single best one.

     So this takes the MAXIMUM of the candidates, never the sum. Summing them
     would show a total below what checkout charges, and a number that goes up
     at the last screen is what makes someone abandon, or refuse the parcel at
     the door once it arrives.

     Free delivery is a shipping discount with productDiscounts = true, so it
     does stack on top. That is handled separately in render().

     If you change a discount in admin, change the matching offer metafield on
     the product too, or the two will drift apart. */

  /* Value of one product's own multi-buy offer, across every line of it. */
  function ownOfferValue(lines, productId) {
    var mine = lines.filter(function (l) { return String(l.productId) === String(productId); });
    if (!mine.length) return 0;

    var units = mine.reduce(function (a, l) { return a + l.qty; }, 0);
    var freeEvery = mine[0].freeEvery || 0;
    var minQty = mine[0].minQty || 0;
    var amountOff = mine[0].amountOff || 0;

    // Every Nth unit free. Shopify gives away the cheapest qualifying unit.
    if (freeEvery > 0) {
      var freeCount = Math.floor(units / freeEvery);
      if (freeCount <= 0) return 0;
      var cheapest = mine.reduce(function (m, l) { return Math.min(m, l.price); }, Infinity);
      return freeCount * cheapest;
    }

    // A fixed amount off every unit once the minimum quantity is reached.
    if (minQty > 1 && amountOff > 0 && units >= minQty) {
      return amountOff * units;
    }

    return 0;
  }

  /* Cross-model offer: buy any qualifying product and a different one drops in
     price. Buy X get Y repeats, so it applies once per qualifying pair. */
  function crossOfferValue(lines) {
    var buyUnits = 0;
    var getLines = [];

    lines.forEach(function (l) {
      if (l.xbuy) buyUnits += l.qty;
      if (l.xget && l.xamount > 0) getLines.push(l);
    });

    if (!buyUnits || !getLines.length) return 0;

    var getUnits = getLines.reduce(function (a, l) { return a + l.qty; }, 0);
    var applications = Math.min(buyUnits, getUnits);
    if (applications <= 0) return 0;

    // Never take an item below zero.
    var per = Math.min(getLines[0].xamount, getLines[0].price);
    return applications * per;
  }

  /* The single best discount, which is what Shopify will actually apply. */
  function bestDiscount(lines) {
    if (!lines.length) return { value: 0, label: '' };

    var seen = {};
    var best = { value: 0, label: '' };

    lines.forEach(function (l) {
      if (seen[l.productId]) return;
      seen[l.productId] = true;
      var v = ownOfferValue(lines, l.productId);
      if (v > best.value) {
        best = { value: v, label: (l.freeEvery > 0 ? 'Free item' : 'Multi-buy offer') };
      }
    });

    var x = crossOfferValue(lines);
    if (x > best.value) best = { value: x, label: 'Complete the look' };

    return best;
  }

  /* ================= Render ================= */

  function render() {
    var rows = qtyRows();
    var extras = addonRows();
    var units = rows.reduce(function (a, r) { return a + r.qty; }, 0);

    // Add-ons are part of the same basket, so they count toward the discount
    // maths exactly as they will at checkout.
    var all = rows.concat(extras);

    var sub = 0;
    all.forEach(function (r) { sub += r.price * r.qty; });

    var best = bestDiscount(all);
    var saved = best.value;
    var afterOffers = sub - saved;

    /* Free delivery is judged on what she actually pays, never on the price
       before the offer came off, so the page can only understate how close she
       is. A surprise at the door is what gets parcels refused. */
    var freeMin = cfg.freeShippingMin || 0;
    var qualifies = freeMin > 0 && afterOffers >= freeMin;
    var ship = qualifies ? 0 : cfg.shippingRate || 0;

    if (el.lines) {
      el.lines.innerHTML = '';
      rows.concat(extras).forEach(function (r) {
        var div = document.createElement('div');
        div.className = 'ss-summary__row';
        var left = document.createElement('span');
        left.textContent = r.title + (r.option ? ' · ' + r.option : '') + ' ×' + r.qty;
        var right = document.createElement('span');
        right.textContent = money(r.price * r.qty);
        div.appendChild(left);
        div.appendChild(right);
        el.lines.appendChild(div);
      });
    }

    if (el.subtotal) el.subtotal.textContent = money(sub);
    if (el.shipping) el.shipping.textContent = ship === 0 ? 'Free' : money(ship);
    if (el.total) el.total.textContent = money(afterOffers + ship);

    /* The sticky bar shows the items only. Delivery belongs next to the form
       where she can see what it is and why, not bolted onto a button. */
    if (el.stickyTotal) el.stickyTotal.textContent = money(afterOffers);

    if (el.savingRow) {
      if (saved > 0) {
        if (el.savingLabel) el.savingLabel.textContent = best.label || 'Offer';
        if (el.saving) el.saving.textContent = '-' + money(saved);
        el.savingRow.hidden = false;
      } else {
        el.savingRow.hidden = true;
      }
    }

    if (el.submit) {
      var label = el.submit.querySelector('[data-ss-submit-label]');
      if (label) label.textContent = cfg.submitLabel || 'Complete order';
    }

    if (units > 0 && el.qtyError) el.qtyError.textContent = '';

    nudges(units, afterOffers, qualifies, freeMin, rows);
  }

  function nudges(units, afterOffers, qualifies, freeMin, rows) {
    if (el.offerNudge) {
      var text = '';
      var unit = rows.length ? rows[0].price : 0;

      if (offer.freeEvery > 0 && units > 0) {
        var toFree = offer.freeEvery - (units % offer.freeEvery);
        if (toFree !== offer.freeEvery) {
          text = 'Add ' + toFree + ' more and one of them is free.';
        }
      } else if (offer.minQty > 1 && offer.amountOff > 0 && units > 0 && units < offer.minQty) {
        var need = offer.minQty - units;
        text =
          'Add ' + need + ' more, in any size or colour, and every one drops to ' +
          money(unit - offer.amountOff) + '.';
      }

      /* If the cross-model offer is sitting there unticked and it would beat
         whatever is currently applied, say so. It is the single easiest thing
         she can do to spend less per item. */
      if (!text && units > 0 && cfg.xbuy) {
        var waiting = form.querySelector('[data-ss-addon][data-xget="true"]:not(:checked)');
        if (waiting) {
          var off = parseInt(waiting.getAttribute('data-xamount'), 10) || 0;
          var full = parseInt(waiting.getAttribute('data-full-price'), 10) || 0;
          if (off > 0 && full > 0) {
            text = 'Tick ' + (waiting.getAttribute('data-title') || 'the add-on') +
              ' below and it drops to ' + money(full - off) + '.';
          }
        }
      }

      el.offerNudge.textContent = text;
      el.offerNudge.hidden = text === '';
    }

    if (el.shipNudge) {
      if (freeMin <= 0 || afterOffers <= 0) {
        el.shipNudge.hidden = true;
      } else if (qualifies) {
        el.shipNudge.textContent = 'Delivery is free on this order.';
        el.shipNudge.hidden = false;
      } else {
        el.shipNudge.textContent = money(freeMin - afterOffers) + ' more and delivery is free.';
        el.shipNudge.hidden = false;
      }
    }
  }

  /* ================= Variant swatches =================
     These used to change the hidden variant id and nothing else, so the page
     looked dead: the swatch moved, the label still said Cream and the gallery
     still showed the cream photograph. */

  function chosenOptions() {
    var chosen = {};
    form.querySelectorAll('[data-ss-option]:checked').forEach(function (i) {
      chosen[i.getAttribute('data-ss-option')] = i.value;
    });
    return chosen;
  }

  function variantFor(chosen) {
    return variants.filter(function (v) {
      return (v.options || []).every(function (opt, i) {
        var key = 'option' + (i + 1);
        return chosen[key] === undefined || chosen[key] === opt;
      });
    })[0];
  }

  function showMedia(index) {
    if (!el.gallery || typeof index !== 'number') return;
    var items = el.gallery.children;
    if (!items.length || index < 0 || index >= items.length) return;

    var item = items[index];
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var behavior = reduce ? 'auto' : 'smooth';

    // Horizontal scroller on mobile, vertical stack on desktop.
    if (el.gallery.scrollWidth > el.gallery.clientWidth + 4) {
      var delta = item.getBoundingClientRect().left - el.gallery.getBoundingClientRect().left;
      el.gallery.scrollTo({ left: el.gallery.scrollLeft + delta, behavior: behavior });
    } else {
      item.scrollIntoView({ behavior: behavior, block: 'nearest' });
    }

    if (el.dots) {
      var buttons = el.dots.querySelectorAll('button');
      for (var i = 0; i < buttons.length; i++) {
        if (i === index) buttons[i].setAttribute('aria-current', 'true');
        else buttons[i].removeAttribute('aria-current');
      }
    }
  }

  function refreshAvailability() {
    var chosen = chosenOptions();
    form.querySelectorAll('[data-ss-option]').forEach(function (input) {
      var key = input.getAttribute('data-ss-option');
      var test = {};
      Object.keys(chosen).forEach(function (k) { if (k !== key) test[k] = chosen[k]; });
      test[key] = input.value;

      var candidates = variants.filter(function (v) {
        return (v.options || []).every(function (opt, i) {
          var k = 'option' + (i + 1);
          return test[k] === undefined || test[k] === opt;
        });
      });

      input.disabled = candidates.length > 0 && !candidates.some(function (v) { return v.available; });
    });
  }

  var lastVariantId = null;

  function applyVariant(match) {
    if (!match) return;

    form.querySelectorAll('[data-ss-optval]').forEach(function (node) {
      var position = parseInt(node.getAttribute('data-ss-optval'), 10);
      var value = (match.options || [])[position - 1];
      if (value) node.textContent = value;
    });

    if (el.priceNow) el.priceNow.textContent = money(match.price);

    showMedia(match.mediaIndex);
    refreshAvailability();

    /* Moving the swatches is browsing, not adding. If she has exactly one item
       chosen and it is the one she was just looking at, follow her to the new
       colour or size. The moment she has deliberately built a multi-size order,
       stop touching it: quietly stacking a second colour into the basket
       because she compared them is how wrong parcels get sent out. */
    var row = form.querySelector('[data-ss-qrow][data-variant="' + match.id + '"]');
    var rows = qtyRows();
    var units = rows.reduce(function (a, r) { return a + r.qty; }, 0);

    if (row) {
      if (units === 0) {
        setQty(row, 1);
      } else if (units === 1 && lastVariantId && String(rows[0].id) === String(lastVariantId)) {
        var previous = form.querySelector('[data-ss-qrow][data-variant="' + lastVariantId + '"]');
        if (previous && previous !== row) {
          setQty(previous, 0);
          setQty(row, 1);
        }
      }
    }

    lastVariantId = match.id;
    render();

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  form.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-ss-option]')) {
      applyVariant(variantFor(chosenOptions()));
    } else if (t.matches('[data-ss-addon], [data-ss-addon-variant], [data-ss-qty-input]')) {
      render();
    }
  });

  /* ================= Policy sheets =================
     Size guide, shipping and returns open over the form instead of navigating
     away. Answering a question should never cost her the page she was on. */

  var lastFocus = null;

  function openSheet(id) {
    var sheet = document.getElementById(id);
    if (!sheet) return;
    lastFocus = document.activeElement;
    sheet.classList.add('is-open');
    document.body.classList.add('ss-sheet-open');
    var close = sheet.querySelector('[data-ss-sheet-close]');
    if (close) close.focus();
  }

  function closeSheet(sheet) {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    document.body.classList.remove('ss-sheet-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-ss-sheet-open]');
    if (open) {
      e.preventDefault();
      openSheet(open.getAttribute('data-ss-sheet-open'));
      return;
    }
    var close = e.target.closest && e.target.closest('[data-ss-sheet-close]');
    if (close) {
      e.preventDefault();
      closeSheet(close.closest('.ss-sheet'));
      return;
    }
    // Tapping the dimmed area behind the panel closes it too.
    if (e.target.classList && e.target.classList.contains('ss-sheet')) closeSheet(e.target);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openSheetEl = document.querySelector('.ss-sheet.is-open');
      if (openSheetEl) closeSheet(openSheetEl);
    }
  });

  /* ================= Recovery lead ================= */

  function saveLead() {
    var name = fieldOf('name');
    var phone = fieldOf('phone');
    if (!name || !phone) return;
    if (name.value.trim().length < 3 || !rules.phone.test(phone.value)) return;
    try {
      localStorage.setItem('ss-lead', JSON.stringify({
        name: name.value.trim(),
        phone: phone.value.trim(),
        product: cfg.productTitle,
        url: window.location.pathname,
        at: Date.now()
      }));
    } catch (e) {}
  }

  /* ================= Sticky bar ================= */

  if (el.sticky && el.submit) {
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          el.sticky.classList.toggle('is-shown', !entry.isIntersecting);
        });
      }, { rootMargin: '0px 0px -80px 0px' }).observe(el.submit);
    }
    var stickyBtn = el.sticky.querySelector('button');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = fieldOf('name');
        if (first) setTimeout(function () { first.focus(); }, 400);
      });
    }
  }

  /* ================= Submit ================= */

  var submitting = false;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (submitting) return;

    if (el.hp && el.hp.value !== '') return;

    try {
      var last = parseInt(localStorage.getItem('ss-last-submit') || '0', 10);
      if (Date.now() - last < 3000) return;
    } catch (err) {}

    var rows = qtyRows();
    if (!rows.length) {
      if (el.qtyError) el.qtyError.textContent = 'Please choose at least one size before ordering.';
      var matrix = form.querySelector('[data-ss-qmatrix]');
      if (matrix) matrix.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    var firstBad = null;
    Object.keys(rules).forEach(function (name) {
      if (!validateField(name) && !firstBad) firstBad = name;
    });

    if (firstBad) {
      var bad = fieldOf(firstBad);
      if (bad) {
        bad.focus();
        bad.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      var live = form.querySelector('[data-ss-live]');
      if (live) live.textContent = 'Please check the highlighted fields and try again.';
      return;
    }

    submitting = true;
    form.classList.add('is-busy');
    if (el.submit) {
      el.submit.disabled = true;
      el.submit.setAttribute('aria-busy', 'true');
    }

    try {
      localStorage.setItem('ss-last-submit', String(Date.now()));
      localStorage.removeItem('ss-lead');
    } catch (err) {}

    function get(n) {
      var f = fieldOf(n);
      return f ? f.value.trim() : '';
    }

    var name = get('name');
    var space = name.indexOf(' ');
    var first = space > 0 ? name.slice(0, space) : name;
    var last2 = space > 0 ? name.slice(space + 1) : '';

    var p = new URLSearchParams();
    p.set('checkout[shipping_address][first_name]', first);
    p.set('checkout[shipping_address][last_name]', last2);
    p.set('checkout[shipping_address][phone]', get('phone'));
    p.set('checkout[shipping_address][address1]', get('address'));
    p.set('checkout[shipping_address][address2]', get('area'));
    p.set('checkout[shipping_address][city]', get('area'));
    p.set('checkout[shipping_address][province]', get('governorate'));
    p.set('checkout[shipping_address][country]', 'Egypt');

    p.set('attributes[Governorate]', get('governorate'));
    p.set('attributes[Area]', get('area'));
    p.set('attributes[Phone]', get('phone'));
    p.set('attributes[Payment]', 'Cash on delivery');
    if (get('notes')) p.set('note', get('notes'));

    // Every size and every add-on rides on one permalink, so it stays one
    // cash-on-delivery order and one delivery rather than several.
    var items = rows.map(function (r) { return r.id + ':' + r.qty; });
    addonRows().forEach(function (r) { items.push(r.id + ':1'); });

    window.location.href =
      window.Shopify.routes.root + 'cart/' + items.join(',') + '?' + p.toString();
  });

  /* ================= Start ================= */

  (function init() {
    var wanted = new URLSearchParams(window.location.search).get('variant');
    var start = null;

    if (wanted) {
      start = variants.filter(function (v) { return String(v.id) === String(wanted); })[0];
    }
    if (!start) {
      start = variantFor(chosenOptions());
    }

    if (start) {
      form.querySelectorAll('[data-ss-option]').forEach(function (input) {
        var position = parseInt(input.getAttribute('data-ss-option').replace('option', ''), 10);
        if ((start.options || [])[position - 1] === input.value) input.checked = true;
      });
      applyVariant(start);
    } else {
      refreshAvailability();
      render();
    }
  })();
})();
